import React, { useState } from "react";
import { Button, Form, Grid, GridRow, Header, Image, Segment } from "semantic-ui-react";
import configs from "../helpers/config";
import loginService from "../services/login.service";
import recuperacaoService from "../services/recuperacao.service";
import LinkButton from "./LinkButton";
import { application_agnostic_auth_token } from "./Login";
import { showMessage } from '../helpers/helper';
import colaboradorIcon from "../img/colaborador.svg";

class LoginColaborador extends React.Component {
    constructor(props) {
        super(props);
        this.state = { ...configs.DEFAULT_MEDICO_COLABORADOR };
        this.inputs = [];
    }     

    handleLogin() {
        const { codigo, senha } = this.state;

        if (codigo && senha) {
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(configs.RECAPTCHA_SITE_KEY, { action: "PortalResultadosLoginPaciente" }).then((token) => {
                    this.setState({ recaptcha_token: token });
                    this.props.onClick({ ...this.state });
                    this.setState({ ...configs.DEFAULT_MEDICO_COLABORADOR });
                });
            });
        } else {
            showMessage('Insira a os dados de acesso corretamente');
        }
    }

    render() {
        return (
            <Segment className={this.props.className}>
                <Header as="h2">
                    <p className="headerLogin">
                        <Image src={colaboradorIcon} className="imgAvatarColaborador" avatar />
                        SECRETÁRIA
                    </p>
                </Header>
                <Form size="large">
                    <GridRow>
                        <p>Acesso direto ao portal de consultorios</p>
                        <Form.Input
                            fluid
                            icon='at'
                            iconPosition='left'
                            placeholder='Email'
                            value={this.state.codigo}
                            onChange={(e) => this.setState({ ...this.state, codigo: e.target.value })}
                        />
                        <Form.Input
                            fluid
                            icon='lock'
                            iconPosition='left'
                            placeholder='Senha'
                            value={this.state.senha}
                            type='password'
                            onChange={(e) => this.setState({ ...this.state, senha: e.target.value })}
                        />
                        <Button fluid size='large' onClick={() => this.handleLogin()}>
                            ENTRAR
                        </Button >
                        <br />
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <LinkButton onClick={this.props.recuperar} >Esqueci minha senha</LinkButton>
                        </div>
                    </GridRow>
                </Form>

            </Segment >);
    }
}

export default LoginColaborador;
